import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Distribution2Component } from "../distribution-2/distribution-2.component";
import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule } from "ngx-bootstrap";
import { AgmCoreModule } from "@agm/core";
import { SelectModule } from "ng-select";
import {
  ConfirmationService,
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { ImageService } from "../../../imageService";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule,
    ModalModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyC0fgs5qkpOIDJRXBNG8mNApwwFk30qhMs",
    }),
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
  ],
  declarations: [Distribution2Component],
})
export class Distribution2Module {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-2/distribution-2.module.ts